/* eslint-disable no-underscore-dangle */
import React, {
  memo, useState,
} from 'react';
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTablePart } from '../../../../BaseEditor/tablePart/hook';
import TPCommandPanel from '../../../../BaseEditor/tablePart/commandPanels/materialCommandPanel';
import Row from './row';
import PrintDialog from '../../print/printDialog';

const defaultRecord = () => ({
  date: new Date().toJSON().slice(0, 10),
  order_amount: 0,
});

const printUrl = '/api/household/print_warehouse/';

function PrintWarehouse({ activeRow, setModalOpened }) {
  return (
    <Button
      size="small"
      onClick={() => {
        setModalOpened(true);
      }}
      disabled={!activeRow}
      variant="outlined"
      startIcon={<FontAwesomeIcon icon={faPrint} />}
    >
      Довідка про склад сім`ї
    </Button>
  );
}

PrintWarehouse.propTypes = {
  setModalOpened: PropTypes.func.isRequired,
  activeRow: PropTypes.number,
};

PrintWarehouse.defaultProps = {
  activeRow: null,
};

function PaymentTablePart({
  data, options, onChange, readOnly,
}) {
  const {
    displayedItems, fields, actions, permissions, activeRow,
    pages, currentPage, getControlTP,
  } = useTablePart({
    data, options, onChange, readOnly, defaultRecord,
  });
  const [modalOpened, setModalOpened] = useState(false);

  const idHeadMember = data.reduce((res, el) => {
    if (el.id === activeRow) {
      return {
        idHeadMember: el.member.id,
        idDoc: el.household,

      };
    }
    return res;
  }, null);

  return (
    <>
      <TPCommandPanel
        actions={actions}
        permissions={permissions}
        pages={pages}
        currentPage={currentPage}
        activeRow={activeRow}
      >
        <PrintWarehouse
          activeRow={activeRow}
          data={data}
          setModalOpened={setModalOpened}
        />
      </TPCommandPanel>

      <TableContainer component={Paper} sx={{ maxHeight: '60vh' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                {fields.member.label}
              </TableCell>
              <TableCell width="20%">
                {fields.relation.label}
              </TableCell>
              <TableCell width="15%">
                Ведення особистого селянського господарства
              </TableCell>
              <TableCell width="10%">
                {fields.is_owner.label}
              </TableCell>
              <TableCell width="10%">
                {fields.part.label}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedItems.map((row) => (
              <Row
                actions={actions}
                row={row}
                readOnly={readOnly}
                fields={fields}
                key={row.id}
                active={activeRow === row.id}
                getControlTP={getControlTP}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {modalOpened && (
      <PrintDialog
        param={idHeadMember}
        printUrl={printUrl}
        modalOpened={modalOpened}
        setModalOpened={setModalOpened}
      />
      )}
    </>
  );
}

PaymentTablePart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({

  })).isRequired,
  options: PropTypes.shape({
    child: PropTypes.shape({
      children: PropTypes.shape(),
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

PaymentTablePart.defaultProps = {
  readOnly: false,
};

export default memo(PaymentTablePart);
